'use strict'

var Marionette = require('marionette')
var App = require('app')
var TabBehavior = require('src/behaviors/tabs')
var _ = require('lodash')

var FilterLocation = require('./views/filter-location')
var FilterText = require('./views/filter-text')
var FilterSelect = require('./views/filter-select')
var FilterMultiSelect = require('./views/filter-multi-select')

// -- Add Filter ------------------------------------------- //
var FilterAddOption = Marionette.View.extend({
  template: function (model) { return model.label },
  tagName: 'li',
  triggers: {
    'click': 'filter:add'
  }
})

var FilterAddLayout = Marionette.CompositeView.extend({
  template: require('./templates/filter-add.html'),
  tagName: 'span',
  childView: FilterAddOption,
  childViewContainer: '.filter-popup__list',
  initialize: function () {
    // system to close the popup when clicked outside.
    // not sure about this though
    this.onCheckClickOutsideFn = _.bind(this.onCheckClickOutside, this)
    document.addEventListener('click', this.onCheckClickOutsideFn)
  },
  onCheckClickOutside: function (ev) {
    var isClickInside = this.el.contains(ev.target)
    if (!isClickInside) {
      this.hidePopupEl()
    }
  },
  onDomRefresh: function () {
    this.popupEl = this.el.querySelector('.js-filter-add .js-filter-popup')
  },
  events: {
    'click .js-filter-toggle': 'onToggleFilterAdd'
  },
  onToggleFilterAdd: function (ev) {
    this.popupEl.classList.toggle('is-visible')
  },
  hidePopupEl: function () {
    this.popupEl.classList.remove('is-visible')
  },
  onDestroy: function () {
    document.removeEventListener('click', this.onCheckClickOutsideFn)
  }
})

module.exports.FilterAddLayout = FilterAddLayout

// -- Filters list ------------------------------------------- //

/**
 * This layout wraps around all the selected filters. Is responsible
 * for showing the popup etc.
 */
var FilterLayout = Marionette.View.extend({
  template: require('./templates/filter.html'),
  tagName: 'li',
  className: 'filter-group',
  regions: {
    filterBodyRegion: '.filter-body__region'
  },
  events: {
    'click .js-remove': 'onRemove',
    'click .js-apply': 'onApply',
    'click .filter-group__button': 'onTogglePopupShow'
  },
  modelEvents: {
    'change': 'onChange'
  },
  initialize: function (args) {
    // system to close the popup when clicked outside.
    // not sure about this though
    this.onCheckClickOutsideFn = _.bind(this.onCheckClickOutside, this)
    document.addEventListener('click', this.onCheckClickOutsideFn)

    document.addEventListener('keyup', this.onKeyUp.bind(this))
  },
  onKeyUp: function (ev) {
    if (this.model.get('popupVisible') && ev.keyCode === 13) {
      this.onApply()
    }
  },
  onCheckClickOutside: function (ev) {
    var isClickInside = this.el.contains(ev.target)
    if (!isClickInside) {
      // only apply and hide the filter when the popup is visible
      if (this.model.get('popupVisible')) this.onApply()
    }
  },
  onChange: function (model) {
    if (!model) return false
    if (model.get('popupVisible')) {
      this.popupEl.classList.add('is-visible')

      let filterView = this.getChildView('filterBodyRegion')
      if (typeof filterView.onActivate === 'function') filterView.onActivate()
    } else {
      this.popupEl.classList.remove('is-visible')
    }
  },
  onTogglePopupShow: function () {
    this.model.set('popupVisible', !this.model.get('popupVisible'))
  },
  hidePopupEl: function () {
    this.model.set('popupVisible', false)
  },
  onRemove: function (ev) {
    this.trigger('filter:remove', this)
  },
  generateFieldLabel: function () {
    switch (this.model.get('type')) {
      case 'select':
      case 'multi_select':
        var selected = []
        selected = _.map(_.filter(this.model.get('collection').models, function (o) { return o.get('selected') }), function (o) {
          return o.get('label')
        })
        if (selected.length > 0) return selected.join(', ')
        return this.model.get('fieldLabel')
        break
      case 'location':
        var value = this.model.get('value')
        var location = value.location
        if (!location) return 'Choose location...'
        return 'lat: ' + location[0] + ', lng: ' + location[1]
        break
      case 'text':

        var value = this.model.get('value') || this.model.get('selectedValues')
        if (value) return value
        return 'Enter..'
        break
    }
  },
  updateLabel: function () {
    var element = this.el.querySelector('.js-group-button-label')
    element.innerHTML = this.generateFieldLabel()
  },
  onApply: function (ev) {
    this.trigger('filter:apply')
    this.hidePopupEl()
    this.updateLabel()
  },
  onDomRefresh: function () {
    this.popupEl = this.el.querySelector('.js-filter-popup')
  },
  onRender: function () {
    var self = this
    switch (this.model.get('type')) {
      case 'location':
        this.filterBodyView = new FilterLocation({model: this.model})
        this.listenTo(this.filterBodyView, 'updated', _.bind(self.updateLabel, self))
        break
      case 'select':
        this.filterBodyView = new FilterSelect({collection: this.model.get('collection')})
        this.listenTo(this.filterBodyView, 'updated', _.bind(self.updateLabel, self))
        break
      case 'multi_select':
        this.filterBodyView = new FilterMultiSelect({collection: this.model.get('collection')})
        this.listenTo(this.filterBodyView, 'updated', _.bind(self.updateLabel, self))
        break
      case 'text':
        this.filterBodyView = new FilterText({model: this.model})
        this.listenTo(this.filterBodyView, 'updated', _.bind(self.updateLabel, self))

        break
    }
    this.showChildView('filterBodyRegion', this.filterBodyView)
    if (this.model.get('type') === 'text') this.filterBodyView.onActivate()
  },
  onDestroy: function () {
    document.removeEventListener('keyup', this.onKeyUp)
  },
  templateContext: function () {
    var self = this
    return {
      'getFieldLabel': function () {
        var label = self.generateFieldLabel()
        return self.generateFieldLabel()
      }
    }
  }
})
module.exports.FilterLayout = FilterLayout

var FiltersLayout = Marionette.CollectionView.extend({
  tagName: 'ul',
  className: 'filters__list ',
  childView: FilterLayout
})

module.exports.FiltersLayout = FiltersLayout
// -- Layout ------------------------------------------- //

var Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  regions: {
    filtersRegion: '.filters__list-region',
    filterAddRegion: '.filter-add__region'
  },
  events: {
    'click .js-remove': 'onRemove',
    'click .js-apply': 'onApply'
  },
  templateContext: function () {
    var self = this
    return {
      'getFilterTitle': function () {
        if (!self.options.filterOptions) {
          return false
        }
        return self.options.filterOptions.title
      }
    }
  }
})

module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/components/devices-filter/view.js